<template lang="pug">
.v-header.header
	.header__top(v-if="!isTablet")
		.container
			.header__top-inner
				slot(name="top-links")
				.header__top-buttons
					.header__top-btn-item
						button.header__top-btn.js-open-search(type="button")
							v-svg-icon.header__top-btn-icon(icon="graphic-search")
					.header__top-btn-item
						v-scope
							v-dropdown(:direction="'left'")
								template(#btn)
									button.header__top-btn(type="button")
										v-svg-icon.header__top-btn-icon(icon="graphic-call")
								template(#content)
									slot(name="contacts")
					.header__top-btn-item
						slot(name="header-atms")
	.header__main
		.container
			.header__main-inner
				slot(name="logo")
				template(v-if="!isTablet")
					.header__menu
						slot(name="menu")
					.header__buttons
						slot(name="buttons")
				template(v-if="isTablet")
					.header__mob-menu
						slot(name="mob-menu")


</template>

<script>

import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {

	mixins: [
		isMobMixin
	],

	data() {
		return {}
	}
}

</script>